<template>
    <div>
        <div style=" height: calc(100vh - 341px);overflow: auto;">
            <div class="page_box">
                <div class="box_top border_none">
                    <span class="box_title">数据查询</span>
                </div>
                <div class="box_content">
                    <div class="list_content">
                        <ul>
                            <li class="search_title">留言类型</li>
                            <div style="float: left;width: 950px;padding: 7px 0;">
                                <li class="search_item"
                                    :class="{'search_item_current': searchData.messageTypeId == ''}"
                                    @click="searchMsgType('')">全部</li>
                                <li class="search_item"
                                    :class="{'search_item_current': searchData.messageTypeId == item.id}"
                                    @click="searchMsgType(item.id)"
                                    v-for="item in msgType.list">{{item.name}}</li>
                            </div>

                        </ul>
                        <ul>
                            <li class="search_title">留言状态</li>
                            <li class="search_item"
                                :class="{'search_item_current': searchData.messageState === ''}"
                                @click="searchMsgState('')">全部</li>
                            <li class="search_item"
                                :class="{'search_item_current': searchData.messageState === 0}"
                                @click="searchMsgState(0)">待回复</li>
                            <li class="search_item"
                                :class="{'search_item_current': searchData.messageState == 1}"
                                @click="searchMsgState(1)">已回复</li>
                            <li class="search_item"
                                :class="{'search_item_current': searchData.messageState == 2}"
                                @click="searchMsgState(2)">已关闭</li>
                            <li class="search_item"
                                :class="{'search_item_current': searchData.messageState == 3}"
                                @click="searchMsgState(3)">已退回</li>
                        </ul>
                        <ul>
                            <li class="search_title">发帖时间</li>
                            <li class="search_item"
                                @click="changeAddTime('nowYear', -1)"
                                :class="{'search_item_current': addTimeIndex == -1}">本年</li>
                            <li class="search_item"
                                @click="changeAddTime('nowMonth', 0)"
                                :class="{'search_item_current': addTimeIndex == 0}">本月</li>
                            <li class="search_item"
                                @click="changeAddTime('nowWeek', 1)"
                                :class="{'search_item_current': addTimeIndex == 1}">本周</li>
                            <li class="search_item"
                                @click="changeAddTime('yestoday', 2)"
                                :class="{'search_item_current': addTimeIndex == 2}">昨天</li>
                            <li class="search_item"
                                @click="changeAddTime('today', 3)"
                                :class="{'search_item_current': addTimeIndex == 3}">今天</li>
                            <li class="search_item"
                                @click="changeAddTime('', 4)"
                                :class="{'search_item_current': addTimeIndex == 4}">
                                <a-range-picker v-model="time1"
                                                @change="changeTime1">
                                    <div v-if="addTimeIndex == 4"
                                         :class="{'search_item_current': addTimeIndex == 4}">
                                        {{ addTimeIndex == 4 && time1 ?   moment(time1[0]).format("YYYY-MM-DD") + ' ~ ' + moment(time1[1]).format("YYYY-MM-DD") : '开始日期 ~ 结束日期'}}
                                    </div>
                                    <div v-else>
                                        请选择
                                    </div>
                                </a-range-picker>
                            </li>

                        </ul>
                        <ul>
                            <li class="search_title">更新时间</li>
                            <li class="search_item"
                                @click="changeUpdateTime('nowYear', -1)"
                                :class="{'search_item_current': updateTimeIndex == -1}">本年</li>
                            <li class="search_item"
                                @click="changeUpdateTime('nowMonth', 0)"
                                :class="{'search_item_current': updateTimeIndex == 0}">本月</li>
                            <li class="search_item"
                                @click="changeUpdateTime('nowWeek', 1)"
                                :class="{'search_item_current': updateTimeIndex == 1}">本周</li>
                            <li class="search_item"
                                @click="changeUpdateTime('yestoday', 2)"
                                :class="{'search_item_current': updateTimeIndex == 2}">昨天</li>
                            <li class="search_item"
                                @click="changeUpdateTime('today', 3)"
                                :class="{'search_item_current': updateTimeIndex == 3}">今天</li>

                            <li class="search_item"
                                @click="changeUpdateTime('', 4)"
                                :class="{'search_item_current': updateTimeIndex == 4}">
                                <a-range-picker v-model="time2"
                                                @change="changeTime2">
                                    <div v-if="updateTimeIndex == 4"
                                         :class="{'search_item_current': updateTimeIndex == 4}">
                                        {{ updateTimeIndex == 4 && time2 ?   moment(time2[0]).format("YYYY-MM-DD") + ' ~ ' + moment(time2[1]).format("YYYY-MM-DD") : '开始日期 ~ 结束日期'}}
                                    </div>
                                    <div v-else>
                                        请选择
                                    </div>
                                </a-range-picker>
                            </li>
                        </ul>
                        <ul v-if="showMore">
                            <li class="search_title">服务中心</li>

                            <a-select v-model="searchSrc.schoolCampusId"
                                      style="width: 160px;margin-right: 20px;"
                                      @change="getAllSer">
                                <a-select-option value="">全部校区</a-select-option>
                                <a-select-option v-for="item in allCam"
                                                 :value="item.campusId">{{item.campusName}}</a-select-option>
                            </a-select>
                            <a-select v-model="searchSrc.serviceCentreId"
                                      style="width: 160px;margin-right: 20px;">
                                <a-select-option value="">全部服务中心</a-select-option>
                                <a-select-option v-for="item in allSer"
                                                 :value="item.id">{{item.name}}</a-select-option>
                            </a-select>
                            <li class="search_item btn"
                                @click="goSearchSrc()">查询</li>
                        </ul>
                        <ul v-if="showMore">
                            <li class="search_title">回复人员</li>
                            <a-select v-model="searchDep.departmentId"
                                      style="width: 160px;margin-right: 20px;"
                                      @change="getAllRep">
                                <a-select-option value="">全部部门</a-select-option>
                                <a-select-option v-for="item in allDep"
                                                 :value="item.id">{{item.name}}</a-select-option>
                            </a-select>
                            <a-select v-model="searchDep.messageRelyeUserId"
                                      style="width: 160px;margin-right: 20px;">
                                <a-select-option value="">全部回复人员</a-select-option>
                                <a-select-option v-for="item in allRep"
                                                 :value="item.userModel.userId">{{item.userModel.realName}}</a-select-option>
                            </a-select>
                            <li class="search_item btn"
                                @click="goSearchDep()">查询</li>
                        </ul>
                        <ul v-if="showMore">
                            <li class="search_title">搜索留言人</li>
                            <a-input v-model="userName"
                                     placeholder="请输入留言人姓名"
                                     style="width: 160px;margin-right: 20px;"></a-input>
                            <li class="search_item btn"
                                @click="goSearchUserName()">查询</li>
                        </ul>

                        <div class="more_search">
                            <span class="empty"
                                  @click="emptyAll">
                                <my-icon type="iconlajitong"></my-icon>
                                清空筛选项
                            </span>
                            <span class=""
                                  @click="showMoreSearch()">
                                {{`${!showMore ? '更多' : '收起'}筛选项`}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page_box">
                <div class="box_top border_none">
                    <span class="box_title">查询结果</span>
                </div>
                <div class="box_content last_content">
                    <div class="list_content">
                        <div>
                            <a-row class="list_border list_title">
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">留言类型</div>
                                </a-col>
                                <a-col :span="2">
                                    <div class="list_data flex_nowrap">姓名</div>
                                </a-col>
                                <a-col :span="4">
                                    <div class="list_data flex_nowrap">内容</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">发帖时间</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">更新时间</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">应回复单位</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">留言状态</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">回复人</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div>
                            <a-row v-for="item in list">
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.messageTypeName}}</div>
                                </a-col>
                                <a-col :span="2">
                                    <div class="list_data flex_nowrap">{{item.userName}}</div>
                                </a-col>
                                <a-col :span="4">
                                    <div class="list_data flex_nowrap">
                                        <a-popover placement="bottom">
                                            <template slot="content">
                                                <p style="max-width: 300px;">{{item.content}}</p>
                                            </template>
                                            {{item.content}}
                                        </a-popover>
                                    </div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.addTime | timeFormat}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.lastUpdateTime | timeFormat}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.serviceCentreName}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.messageState | messageState}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.messageRelyeUserName || '/'}}</div>
                                </a-col>
                            </a-row>
                            <a-row v-if="list.length == 0">
                                <a-col :span="24">
                                    <div class="list_data flex_nowrap"
                                         style="height: 100px;line-height: 100px;">无查询结果</div>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                    <a-pagination class="page"
                                  :defaultCurrent="page.current"
                                  :defaultPageSize="25"
                                  @change="changePage"
                                  :total="page.count"
                                  :showTotal="total => `共 ${page.count} 条`"
                                  v-if="page.count != 0"
                                  v-model="page.nowPage" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import getTme from "../common/time";
import moment from "moment";
export default {
    data() {
        return {
            time1: undefined,
            time2: undefined,
            moment,
            showMore: false,
            allCam: [],
            allSer: [],
            allDep: [],
            allRep: [],

            page: {
                pageSize: 25,
                count: 0,
                current: 1,
                nowPage: 1
            },
            searchData: {
                messageTypeId: "",
                messageState: "",
                addStartTime: getTme["nowYear"]()[0],
                addEndTime: getTme["nowYear"]()[1],
                updateStartTime: getTme["nowYear"]()[0],
                updateEndTime: getTme["nowYear"]()[1],
                schoolCampusId: "",
                serviceCentreId: "",
                departmentId: "",
                messageRelyeUserId: "",
                userName: ""
            },
            searchSrc: {
                schoolCampusId: "",
                serviceCentreId: ""
            },
            searchDep: {
                departmentId: "",
                messageRelyeUserId: ""
            },
            userName: "",
            addTimeIndex: -1,
            updateTimeIndex: -1,
            list: []
        };
    },
    computed: {
        ...mapGetters(["msgType", "config"])
    },
    created() {
        this.getList(1);
        this.getAllCam();
        this.getAllDep();
    },
    methods: {
        //展开折叠
        showMoreSearch() {
            this.showMore = !this.showMore;
            if (!this.showMore) {
                this.emptyBottom();
                this.getList(1);
            }
        },
        //清空全部数据
        emptyAll() {
            this.searchData = {
                messageTypeId: "",
                messageState: "",
                addStartTime: getTme["nowYear"]()[0],
                addEndTime: getTme["nowYear"]()[1],
                updateStartTime: getTme["nowYear"]()[0],
                updateEndTime: getTme["nowYear"]()[1],
                schoolCampusId: "",
                serviceCentreId: "",
                departmentId: "",
                messageRelyeUserId: "",
                userName: ""
            };
            this.addTimeIndex = -1;
            this.updateTimeIndex = -1;
            this.emptyBottom();
            this.getList(1);
        },
        //清空下面数据
        emptyBottom() {
            this.searchSrc = {
                schoolCampusId: "",
                serviceCentreId: ""
            };
            this.searchDep = {
                departmentId: "",
                messageRelyeUserId: ""
            };
            this.userName = "";
            this.searchData.schoolCampusId = "";
            this.searchData.serviceCentreId = "";
            this.searchData.departmentId = "";
            this.searchData.messageRelyeUserId = "";
            this.searchData.userName = "";

            this.allSer = [];
            this.allRep = [];
        },
        //还原数据
        reductionData() {
            this.searchSrc = {
                schoolCampusId: "",
                serviceCentreId: ""
            };
            this.searchDep = {
                departmentId: "",
                messageRelyeUserId: ""
            };
            this.searchSrc.schoolCampusId = this.searchData.schoolCampusId;
            this.searchSrc.serviceCentreId = this.searchData.serviceCentreId;
            this.searchDep.departmentId = this.searchData.departmentId;
            this.searchDep.messageRelyeUserId = this.searchData.messageRelyeUserId;
            this.userName = this.searchData.userName;

            this.getAllSer();
            this.getAllRep();
        },
        getList(p) {
            this.page.nowPage = p;
            let data = {
                "page.pageSize": this.page.pageSize,
                "page.pageNum": this.page.nowPage,
                "page.sort": "addTime",
                "page.order": "desc"
            };
            Object.keys(this.searchData).forEach(key => {
                data[key] = this.searchData[key];
            });
            this.$api.getSearchList(data).then(res => {
                this.page.count = res.param.page.count;
                this.list = res.param.page.rows;
            });
        },

        //分页相关
        changePage(p) {
            this.getList(p);
        },
        //查询相关
        searchMsgType(id) {
            if (id == this.searchData.messageTypeId) {
                return;
            }
            this.reductionData();
            this.searchData.messageTypeId = id;
            this.getList(1);
        },
        searchMsgState(messageState) {
            if (messageState === this.searchData.messageState) {
                return;
            }
            this.reductionData();
            this.searchData.messageState = messageState;
            this.getList(1);
        },
        changeAddTime(time, index) {
            if (time) {
                if (index == this.addTimeIndex) {
                    return;
                }
                this.addTimeIndex = index;
                this.time1 = undefined;
                this.reductionData();
                this.searchData.addStartTime = getTme[time]()[0];
                this.searchData.addEndTime = getTme[time]()[1];
                this.getList(1);
            } else {
                this.addTimeIndex = index;
            }
        },
        changeTime1() {
            this.searchData.addStartTime =
                moment(this.time1[0]).format("YYYY-MM-DD") + " 00:00:00";
            this.searchData.addEndTime =
                moment(this.time1[1]).format("YYYY-MM-DD") + " 23:59:59";
            this.getList(1);
        },
        changeUpdateTime(time, index) {
            if (time) {
                if (index == this.updateTimeIndex) {
                    return;
                }
                this.reductionData();
                this.time2 = undefined;
                this.updateTimeIndex = index;
                this.searchData.updateStartTime = getTme[time]()[0];
                this.searchData.updateEndTime = getTme[time]()[1];
                this.getList(1);
            } else {
                this.updateTimeIndex = index;
            }
        },
        changeTime2() {
            this.searchData.updateStartTime =
                moment(this.time2[0]).format("YYYY-MM-DD") + " 00:00:00";
            this.searchData.updateEndTime =
                moment(this.time2[1]).format("YYYY-MM-DD") + " 23:59:59";
            this.getList(1);
        },
        getAllCam() {
            this.$api.getAllCam().then(res => {
                this.allCam = res.param.list;
            });
        },
        getAllSer() {
            this.searchSrc.serviceCentreId = "";
            this.$api
                .getAllSer({ schoolCampusId: this.searchSrc.schoolCampusId })
                .then(res => {
                    this.allSer = res.param.list;
                });
        },
        goSearchSrc() {
            this.searchData.schoolCampusId = this.searchSrc.schoolCampusId;
            this.searchData.serviceCentreId = this.searchSrc.serviceCentreId;
            this.getList(1);
        },
        getAllDep() {
            this.$api.getAllDep().then(res => {
                this.allDep = res.param.list;
            });
        },
        getAllRep() {
            this.searchDep.messageRelyeUserId = "";
            this.$api
                .getAllRep({ departmentId: this.searchDep.departmentId })
                .then(res => {
                    this.allRep = res.param.list;
                });
        },
        goSearchDep() {
            this.searchData.departmentId = this.searchDep.departmentId;
            this.searchData.messageRelyeUserId = this.searchDep.messageRelyeUserId;
            this.getList(1);
        },
        goSearchUserName() {
            this.searchData.userName = this.userName;
            this.getList(1);
        }
    },
    filters: {
        messageState(val) {
            if (val == 0) {
                return "待回复";
            } else if (val == 1) {
                return "已回复";
            } else if (val == 2) {
                return "已关闭";
            } else if (val == 3) {
                return "已退回";
            }
        }
    }
};
</script>
<style lang="scss" scope>
.list_content {
    position: relative;
    ul {
        min-height: 40px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        line-height: 40px;
        border-bottom: 1px solid rgb(245, 245, 245);
        margin-bottom: 0;
        li {
            float: left;
        }
        .search_title {
            width: 100px;
        }
        .search_item {
            margin-right: 15px;
            cursor: pointer;
            height: 30px;
            line-height: 30px;
            padding: 0 10px;
            border-radius: 5px;
            position: relative;
        }
        .search_item_current {
            background-color: #3686e3;
            color: #fff;
        }

        .btn {
            width: 80px;
            height: 28px;
            background-color: #ffaa16;
            border-radius: 5px;
            color: #fff;
            text-align: center;
            line-height: 28px;
        }
    }

    .more_search {
        // background: url();
        position: absolute;
        color: #3686e3;
        bottom: 8px;
        right: 12px;
        cursor: pointer;
        text-align: right;

        .empty {
            margin-right: 10px;
            color: #555555;
        }
    }
}
</style>
<style lang="scss">
body .ant-pagination {
    padding-top: 20px;
    padding-bottom: 20px;
    text-align: right;
    margin-right: 10px;
    border-top: 1px solid #c8c8c8;
}
</style>